export const socialMedia = [
    "https://i.ibb.co/4sV548v/facebook.png",
    "https://i.ibb.co/mTXk5tN/dribbble.png",
    "https://i.ibb.co/dGxv5Fh/instagram.png",
    "https://i.ibb.co/MhRzsSK/linkedin.png",
    "https://i.ibb.co/n8vdfJ1/twitter.png",
    "https://i.ibb.co/KNj5fF1/behance.png"
];

export const popularSearch = [
    "Graphics", "Nature", "Social", "Game", "Sports", "Cart", "Text", "Business Card", "Education"
];

export const footerMenus = {
    menuHeading: [
        "Categories",
        "Content",
        "Information",
        "Legal"
    ],
    menus: {
        categories: [
            "Business Card Mockup",
            "Social Media Banner",
            "Logo Mockup",
            "Text Effect"
        ],
        content: [
            "New resources",
            "Most popular content",
            "Search trends",
            "Blog"
        ],
        information: [
            "About us",
            "Sell Your Content",
            "Support",
            "Contact"
        ],
        legal: [
            "Terms & conditions",
            "License Agreement",
            "Copyright information",
            "Cookies policy"
        ],
    }
}